<template>
  <div class="student-score">

    <!-- ══════════════════════════════
         HERO — 学习成效查看面板
    ══════════════════════════════ -->
    <div class="score-hero">
      <!-- 背景装饰 -->
      <div class="sh-grid"></div>
      <div class="sh-glow sh-glow-l"></div>
      <div class="sh-glow sh-glow-r"></div>

      <div class="sh-copy">
        <span class="sh-kicker">
          <span class="sk-dot"></span>
          Score Review
        </span>
        <h1>学习成效查看面板</h1>
        <p>查看参加考核的学员答题记录与成绩详情。</p>
      </div>
    </div>

    <!-- ══════════════════════════════
         课程基本信息
    ══════════════════════════════ -->
    <div class="info">
      <span class="info-tag">
        <i class="el-icon-collection"></i>
        课程：{{ title }}
      </span>
      <span class="info-tag">
        <i class="el-icon-user"></i>
        教师：{{ teacherName }}
      </span>
    </div>

    <!-- ══════════════════════════════
         学员名单
    ══════════════════════════════ -->
    <div class="student-list">
      <div class="sl-header">
        <div class="sl-header-left">
          <span class="sec-kicker">Student Roster</span>
          <h3>参加考试人员名单</h3>
        </div>
        <span class="sl-count">{{ studentList.length }} 人</span>
      </div>
      <div class="sl-tags">
        <span
          class="student-item"
          v-for="(item, index) in studentList"
          :key="index"
          :class="{ active: currentStudentIndex === index }"
          @click="handleClickStudent(item, index)"
        >
          <span class="si-avatar">{{ item.nickName ? item.nickName[0] : '?'  }}</span>
          {{ item.nickName }}
        </span>
      </div>
    </div>

    <!-- ══════════════════════════════
         当前选中学员信息
    ══════════════════════════════ -->
    <div v-if="studentList.length > 0" class="student-info">
      <div class="si-icon-wrap">
        <i class="el-icon-user"></i>
      </div>
      <div>
        <span class="si-label">当前查看</span>
        <strong class="si-name">{{ studentList[currentStudentIndex].nickName }}</strong>
      </div>
    </div>

    <!-- ══════════════════════════════
         成绩详情
    ══════════════════════════════ -->
    <div class="score-list">
      <div class="score-list-header">
        <span class="sec-kicker">Answer Details</span>
        <h3>答题详情</h3>
      </div>

      <div class="score-item" v-for="(score, index) in scoreList" :key="index">
        <!-- 章节标题 -->
        <div class="score-section-title">
          <span class="sst-num">{{ index + 1 }}</span>
          <span class="sst-text">{{ score.caseTitle }}</span>
        </div>

        <!-- 题目列表 -->
        <div
          v-for="(jitem, jindex) in score.contentAnswerVoList"
          :key="jindex"
          class="score"
        >
          <div
            v-for="(kitem, kindex) in jitem.questionAnswerVoList"
            :key="kindex"
          >
            <div class="question">
              <div class="q-top">
                <span class="q-num">Q{{ kindex + 1 }}</span>
                <span class="q-text">{{ kitem.title }}</span>
              </div>
              <div class="q-time" v-if="kitem.createTime">
                <i class="el-icon-time"></i>考试时间：{{ kitem.createTime }}
              </div>
              <div class="answer-box">
                <div class="answer-item answer-user">
                  <span class="ai-label">学员答案</span>
                  <span class="ai-val">{{ kitem.userAnswer ? handleText(Number(kitem.userAnswer)) : '—' }}</span>
                </div>
                <div class="answer-item answer-correct">
                  <span class="ai-label">正确答案</span>
                  <span class="ai-val">{{ kitem.correct ? handleText(Number(kitem.correct)) : '—' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="scoreList.length === 0" class="score-empty">
        <div class="se-icon"><i class="el-icon-document"></i></div>
        <p>请从上方选择学员查看答题详情。</p>
      </div>
    </div>

  </div>
</template>

<script>
import { getStudent, getStudentScore } from "../../api/index";
import { mapState } from "vuex";
import { getIndexToLetter } from "@/utils/utils.js";

export default {
  name: "StudentScore",
  data() {
    return {
      studentList: [],
      scoreList: [],
      code: "",
      currentStudentIndex: 0,
      title: "",
      teacherName: "",
    };
  },
  computed: {
    ...mapState(["id"]),
  },
  created() {
    this.code = this.$route.query.code;
    this.title = this.$route.query.title;
    this.teacherName = this.$route.query.teacherName;
    this.getStudent().then(() => {
      this.getStudentScore(this.studentList[0].userId);
    });
  },
  methods: {
    getStudent() {
      return new Promise((resolve, reject) => {
        const params = {
          code: this.code,
        };
        getStudent(params).then((res) => {
          if (res.code == 200) {
            this.studentList = res.data;
            resolve(true);
          }
        });
      });
    },
    getStudentScore(userId) {
      const formData = new FormData();
      formData.append("code", this.code);
      formData.append("userId", userId);
      getStudentScore(formData).then((res) => {
        this.scoreList = res.data;
      });
    },
    handleClickStudent(item, index) {
      this.currentStudentIndex = index;
      this.getStudentScore(item.userId);
    },
    handleText(index) {
      console.log(index);
      return getIndexToLetter(index);
    },
  },
};
</script>

<style scoped lang="scss">
/* ─────────────────────────────────────────
   Design tokens
───────────────────────────────────────── */
.student-score {
  --bd:      #081c42;
  --bm:      #1557d8;
  --ba:      #1e9bff;
  --cyan:    #20c8ff;
  --gray:    #475569;
  --gray-s:  #64748b;
  --card-bg: rgba(255,255,255,0.92);
  --card-bdr: rgba(168,199,245,0.68);

  min-height: 100vh;
  padding: 30px 24px 70px;
  background:
    radial-gradient(ellipse at 8% 0%, rgba(21,87,216,0.09), transparent 34%),
    radial-gradient(ellipse at 94% 3%, rgba(32,200,255,0.09), transparent 30%),
    linear-gradient(180deg, #f2f7ff 0%, #f5f7fb 48%, #ffffff 100%);
  color: var(--bd);
}

.score-hero,
.info,
.student-list,
.student-info,
.score-list {
  width: min(960px, 100%);
  margin-left: auto;
  margin-right: auto;
}

/* ─────────────────────────────────────────
   HERO
───────────────────────────────────────── */
.score-hero {
  position: relative;
  margin-bottom: 16px;
  padding: 24px 26px;
  border-radius: 20px;
  background: linear-gradient(150deg, rgba(8,22,58,0.97), rgba(10,52,112,0.92));
  border: 1px solid rgba(32,200,255,0.16);
  color: #fff;
  box-shadow: 0 20px 44px rgba(4,14,44,0.18);
  overflow: hidden;
}
.sh-grid {
  position: absolute;
  inset: 0;
  opacity: 0.28;
  background-image:
    linear-gradient(rgba(255,255,255,0.07) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.07) 1px, transparent 1px);
  background-size: 38px 38px;
  pointer-events: none;
}
.sh-glow { position: absolute; border-radius: 50%; filter: blur(14px); pointer-events: none; }
.sh-glow-l { width: 240px; height: 240px; left: -80px; bottom: -80px; background: rgba(21,87,216,0.22); }
.sh-glow-r { width: 180px; height: 180px; right: -40px; top: -40px; background: rgba(32,200,255,0.18); }

.sh-copy { position: relative; z-index: 1; }
.sh-kicker {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 10px;
  padding: 4px 11px;
  border-radius: 999px;
  background: rgba(255,255,255,0.10);
  color: rgba(255,255,255,0.76);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.5px;
}
.sk-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  background: var(--cyan);
  box-shadow: 0 0 8px rgba(32,200,255,0.9);
}
.score-hero h1 { margin: 0 0 6px; font-size: 24px; font-weight: 950; line-height: 1.2; }
.score-hero p  { margin: 0; color: rgba(255,255,255,0.68); font-size: 13px; line-height: 1.72; }

/* ─────────────────────────────────────────
   INFO TAGS
───────────────────────────────────────── */
.info {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
.info-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(255,255,255,0.90);
  border: 1px solid var(--card-bdr);
  color: var(--bm);
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 6px 16px rgba(8,28,66,0.07);
}
.info-tag i { font-size: 14px; }

/* ─────────────────────────────────────────
   STUDENT LIST
───────────────────────────────────────── */
.student-list,
.student-info,
.score-list {
  box-sizing: border-box;
  border-radius: 18px;
  background: var(--card-bg);
  border: 1px solid var(--card-bdr);
  box-shadow: 0 10px 28px rgba(8,28,66,0.07);
}
.student-list { padding: 18px 20px; margin-bottom: 14px; }

.sl-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(168,199,245,0.38);
}
.sl-header-left { }
.sec-kicker {
  display: block;
  color: var(--ba);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.5px;
  margin-bottom: 3px;
}
.sl-header h3 { margin: 0; color: var(--bd); font-size: 16px; font-weight: 950; }
.sl-count {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(21,87,216,0.07);
  border: 1px solid rgba(21,87,216,0.14);
  color: var(--bm);
  font-size: 12px;
  font-weight: 800;
  flex-shrink: 0;
}
.sl-tags { display: flex; flex-wrap: wrap; gap: 8px; }

.student-item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px 7px 8px;
  border-radius: 999px;
  background: rgba(248,251,255,0.9);
  border: 1px solid var(--card-bdr);
  color: var(--bd);
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  transition: all 0.2s ease;
}
.student-item:hover {
  border-color: rgba(30,155,255,0.38);
  background: rgba(21,87,216,0.06);
  color: var(--bm);
}
.student-item.active {
  color: #fff;
  background: linear-gradient(135deg, #1248c8, var(--ba));
  border-color: transparent;
  box-shadow: 0 6px 16px rgba(21,87,216,0.22);
}
.si-avatar {
  width: 24px; height: 24px;
  border-radius: 50%;
  background: rgba(21,87,216,0.12);
  color: var(--bm);
  font-size: 12px;
  font-weight: 900;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  transition: background 0.2s, color 0.2s;
}
.student-item.active .si-avatar {
  background: rgba(255,255,255,0.22);
  color: #fff;
}

/* ─────────────────────────────────────────
   CURRENT STUDENT INFO
───────────────────────────────────────── */
.student-info {
  padding: 14px 18px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.si-icon-wrap {
  width: 38px; height: 38px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, rgba(21,87,216,0.11), rgba(32,200,255,0.14));
  color: var(--bm);
  font-size: 18px;
  flex-shrink: 0;
}
.si-label { display: block; font-size: 11px; color: var(--gray-s); font-weight: 700; margin-bottom: 2px; }
.si-name  { font-size: 16px; font-weight: 950; color: var(--bd); }

/* ─────────────────────────────────────────
   SCORE LIST
───────────────────────────────────────── */
.score-list { padding: 20px; }

.score-list-header { margin-bottom: 16px; padding-bottom: 14px; border-bottom: 1px solid rgba(168,199,245,0.38); }
.score-list-header h3 { margin: 0; color: var(--bd); font-size: 16px; font-weight: 950; }

.score-item {
  padding: 16px 0;
  border-bottom: 1px solid rgba(168,199,245,0.28);
}
.score-item:last-child { border-bottom: none; }

/* Chapter title */
.score-section-title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 14px;
}
.sst-num {
  width: 26px; height: 26px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--bm), var(--ba));
  color: #fff;
  font-size: 12px;
  font-weight: 950;
  flex-shrink: 0;
}
.sst-text { color: var(--bd); font-size: 15px; font-weight: 900; }

/* Question card */
.question {
  margin: 10px 0;
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(248,251,255,0.9);
  border: 1px solid rgba(168,199,245,0.44);
  font-size: 14px;
  line-height: 1.78;
}
.q-top {
  display: flex;
  gap: 9px;
  margin-bottom: 6px;
  align-items: flex-start;
}
.q-num {
  flex-shrink: 0;
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(21,87,216,0.08);
  border: 1px solid rgba(21,87,216,0.14);
  color: var(--bm);
  font-size: 11px;
  font-weight: 900;
  margin-top: 2px;
}
.q-text { color: var(--bd); font-weight: 700; line-height: 1.6; }
.q-time {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
  margin-bottom: 10px;
  color: var(--gray-s);
  font-size: 12px;
}

.answer-box {
  display: grid;
  grid-template-columns: repeat(2, minmax(0,1fr));
  gap: 10px;
  margin-top: 10px;
}
.answer-item {
  padding: 11px 14px;
  border-radius: 13px;
  background: rgba(255,255,255,0.96);
  border: 1px solid var(--card-bdr);
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.answer-user   { border-color: rgba(21,87,216,0.18); }
.answer-correct { border-color: rgba(74,222,128,0.28); }
.ai-label { font-size: 11px; font-weight: 800; color: var(--gray-s); flex-shrink: 0; }
.ai-val   { font-size: 15px; font-weight: 950; color: var(--bd); }
.answer-correct .ai-val { color: #15803d; }

/* Empty state */
.score-empty {
  padding: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}
.se-icon {
  width: 50px; height: 50px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, rgba(21,87,216,0.10), rgba(32,200,255,0.12));
  color: var(--ba);
  font-size: 22px;
}
.score-empty p { color: var(--gray-s); font-size: 13px; }

/* ─────────────────────────────────────────
   RESPONSIVE
───────────────────────────────────────── */
@media (max-width: 720px) {
  .student-score   { padding: 24px 16px 56px; }
  .answer-box      { grid-template-columns: 1fr; }
  .hero-metrics    { flex-wrap: wrap; }
}
</style>
